module.exports = __webpack_public_path__ + "img/ecosen copy.6737b785.png";